"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useError = exports.isErrorState = void 0;
var recoil_1 = require("recoil");
exports.isErrorState = (0, recoil_1.atom)({
    key: "isErrorState",
    default: false,
});
var useError = function () {
    var _a = (0, recoil_1.useRecoilState)(exports.isErrorState), isError = _a[0], setIsError = _a[1];
    return {
        isError: isError,
        setIsError: setIsError,
    };
};
exports.useError = useError;
